import React,{ Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { TabberButton } from "../../../common/custom-form/tabber-button.component";
import ButtonIcon from "../../../button";
import { InputGroup, FormControl } from "react-bootstrap";
import Icons from '../../../icon';
import { DataTable } from "../../../common/table/data-table/data-table-component";
import LineItem from "./invoice-line-item";
import ManageInvoiceLayout from "../../../common/report/reports/Invoice/manage-invoice/manage-invoice-layout.component";
import InvoiceComment from "../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import  InvoiceHistory  from "../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import { Selected_Index } from "../../../../constants/internal-constants";
export default class ManageInvoice extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            startDate: "",           
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    render(){   
        const {selectFilter,dataInfo,startDate,dataTable,listTabInfo,tableSelected,selectedIndex}=this.state;           
        return(

            <ManageInvoiceLayout onGetSelected={this.getDataSelected.bind(this)} closeForm={this.props.closeForm} listData={listTabInfo.Tab} haveHeaderButton={false}>

                {
                    selectedIndex===Selected_Index.i_Zero &&

                            <div className="manage-invoice-container">
                            <div className="manage-invoice-detail">
                                <InputField label="ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="SUB ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PROVIDER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="CURRENCY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="ASSINED USER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                        
                                <InputField label="CREATION DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="EXCHANGE RATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE STATUS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                        
                                <InputField label="INVOICE NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE APPROVE DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                       
                                <InputField label="INVOICE REMATCH DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE DUE DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="BILLING PERIOD" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="ACTUAL INVOICE MONTH" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE EXPECTED DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="RENTAL PERIOD" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="COUNTRY LEVEL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                       
                            <div className="invoice-upload-container">
                                    <span className="invoice-pdf-label">Invoice PDF</span>
                                    <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-filter-button" labelName="Choose File"/> 
                                    <span className="invoice-file-label">No File Selected</span>
                                </div>
                                <div></div>
                                <TabberButton label="Credit Note"/>
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <InputField label="RECURRING CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="REMAINING BALANCE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="LINE ITEMS TOTAL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="ACCOUNT LEVEL GRADES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL TAXES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="OTHER CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="USAGE CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL NET" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="GROSS AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="MISCELLANEOUS CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PAYMENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL AMOUNT TO PAY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="LATER PAYMENT FEES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="CHARGE SUBSCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <DATEPICKER_OR label="INVOICE RECEIPT DATE" startDate={startDate} dateSelected={startDate} selectedDate={(date) => this.setState({startDate:date})}/>
                                <InputField label="INVOICE LOCAL DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE LOADED BY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="END NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                        
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <InputField label="CHECK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="AMOUNT PAID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PAYMENT DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="AP VENDOR ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="REMIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <div></div>
                                <div></div>
                                <div></div>                          
                            </div>
                            <div className="line-item-container">
                                    <div className="line-item-left-container">
                                        <div className="line-item-search-container">
                                            <InputGroup size="sm" className="request-input-header">              
                                                <InputGroup.Text id="inputGroup-sizing-sm">
                                                    <Icons name="search" customClassName="icon-search" size="16px" />
                                                </InputGroup.Text>
                                                <FormControl
                                                    onKeyPress={this.props.searchAction}
                                                    placeholder="Search..."
                                                    aria-label="Small"
                                                    aria-describedby="inputGroup-sizing-sm"
                                            />   
                                            </InputGroup>
                                        </div>  
                                    </div>
                                    <div className="line-item-right-container">
                                        {tableSelected ? 
                                            <LineItem startDate={startDate} getData={this.openLineItem.bind(this)} />                                    
                                        :
                                        <div className="line-item-label-container">
                                            <div className="icon-container">
                                                <Icons name="box-light" customClassName="icon-box-light" size="48px" />
                                            </div>
                                            <span>Please select line item on the left panel or add new item</span>
                                        </div>                                    
                                        }                                  
                                    </div>
                                </div>
                        </div>
                }

                {
                    selectedIndex===Selected_Index.i_One &&
                    < InvoiceHistory dataInfo={dataInfo}/>
                }

                {
                    selectedIndex===Selected_Index.i_Two &&
                    <InvoiceComment dataInfo={this.state.commentData}/>
                }

            </ManageInvoiceLayout>
        )
    }
}